<template>
  <div class="d-flex justify-content-center">
    <blank-document/>
    <modal v-if="modalConfig.show"
           :width="modalConfig.width"
           :disableHeader="true"
           :disableFooter="true">
      <template #body>
        <select-communication-modal :SendCodeRequestServiceI="SendCodeRequestServiceI"
                                    v-if="modalConfig.selectCommunicationInterface"
                                    @selected="sendCodeRequest()" />
        <code-verification-interface v-if="codeVerificationInterfaceConfig.show"
                                     :SendCodeRequestServiceI="SendCodeRequestServiceI"
                                     @resend="sendCodeRequest('resend')"
                                     :data="codeVerificationInterfaceConfig.data"/>
      </template>
    </modal>
  </div>
</template>

<script>
import ValidateLandingServices from '@/modules/validate_landing/services/validateLanding.services';
import SendCodeRequestService from '@/modules/validate_landing/services/sendCodeRequest.service';
import ActivityService from '@/modules/common/services/activity.service';

export default {
  name: 'ValidateLanding',
  data() {
    return {
      SendCodeRequestServiceI: new SendCodeRequestService(),
      modalConfig: {
        show: false,
        selectCommunicationInterface: true,
        width: 320,
      },
      codeVerificationInterfaceConfig: {
        show: false,
        data: false,
      },
    };
  },
  components: {
    Modal: () => import('@/modules/common/components/modal/Modal.vue'),
    SelectCommunicationModal: () => import('../components/SelectCommunicationModal.vue'),
    CodeVerificationInterface: () => import('../components/CodeVerificationInterface.vue'),
    BlankDocument: () => import('@/modules/validate_landing/components/BlankDocument.vue'),
  },
  async created() {
    try {
      const { result: { data } } = await new ValidateLandingServices().retrieveMobilePhones(this.$route.params.document_unique_key);
      this.SendCodeRequestServiceI.setMobilePhones(data);
      this.modalConfig.show = true;
    } catch (e) {
      await this.preventEntering();
    }
  },
  methods: {
    sentCode() {
      this.codeVerificationInterfaceConfig.show = true;
      this.modalConfig.selectCommunicationInterface = false;
      this.modalConfig.width = 430;
    },
    async sendCodeRequest(type) {
      try {
        this.codeVerificationInterfaceConfig.show = false;
        await this.SendCodeRequestServiceI.send(this.$route.params.document_unique_key);
        await this.sentCode();
        if (type === 'resend') {
          setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 172), 0);
        } else {
          setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 168), 0);
        }
      } catch (e) {
        await this.preventEntering(typeof e[0] === 'string' ? e[0] : null);
      }
    },
  },
};
</script>
